import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomPaper from '../../../shared/utils/CustomPaper';
import RaisedButton from "material-ui/RaisedButton";
import moment from "../../../shared/utils/moment_fr";
import AuthService from "../../../../services/AuthService";
import {TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import CustomDatePicker from "../../../shared/utils/CustomDatePicker";
import Checkbox from 'material-ui/Checkbox';
import {connect} from "react-redux";
import {getEntrepriseSalaries} from "../../../../actions/entreprise/actions_entreprise_1";
import Alert from "../../../shared/utils/Alert";
import Chip from "material-ui/Chip";


const styles = {
    chip: {
        margin: 4,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
};

class ExperienceProSalarie extends React.Component {

    initialState = {
        selectedSalarie: null,
        emplois: null,
        input_competences_mobilisees: [],
        input_competence: '',
        input_poste_occupe: '',
        input_date_debut: new Date().toISOString().substring(0, 10),
        input_date_fin: new Date().toISOString().substring(0, 10),
        input_is_current_emploi: false
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmploiDelete = this.handleEmploiDelete.bind(this);
        this.handleCompetenceChange = this.handleCompetenceChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let x = nextProps.salaries.filter(x => x.id === nextProps.match.params.id_salarie)[0] || nextProps.salaries[0];
        x = x || null;
        let STATE = null;
        if (x) {
            STATE = {selectedSalarie: x, emplois: x.emplois}
        }
        return STATE;
    }

    handleChange(event, value) {
        if (typeof value === 'object')
            value = moment(value).format("YYYY-MM-DD");
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleEmploiDelete(x) {
        this.Auth.fetch('/salarie/emploi', {
            method: 'DELETE',
            data: x
        }).then(xx => {
            let selectedSalarie = this.state.selectedSalarie;
            selectedSalarie.emplois = selectedSalarie.emplois.filter(e => e.id !== x.id);
            this.setState({selectedSalarie: selectedSalarie});
        });
    }

    handleCompetenceChange(e, x) {
        if (x.indexOf(';') === 0) {
            return;
        } else if (x.indexOf(';') > 0 && x.length > 2) {
            const c = this.state.input_competences_mobilisees;
            this.setState({
                input_competences_mobilisees: [...c, x.replace(';', '')],
                input_competence: ''
            });
        } else {
            this.setState({
                input_competence: x
            });
        }
    }

    handleSubmit() {
        const x = {
            title: this.state.input_poste_occupe,
            date_debut: this.state.input_date_debut,
            date_fin: this.state.input_date_fin,
            is_current: this.state.input_is_current_emploi ? '1' : '0',
            competences_mobilisees: this.state.input_competences_mobilisees
        };
        this.Auth.fetch("/salarie/" + this.state.selectedSalarie.id + "/emplois", {
            method: 'POST',
            data: x
        }).then(xx => {
            this.props.dispatch(getEntrepriseSalaries());
            this.setState(this.initialState);
        });
    }


    render() {
        const salariesCmpList = [];
        this.props.salaries.map(x =>
            salariesCmpList.push(<MenuItem
                key={x.id}
                value={x.id}
                primaryText={x.nom + " " + x.prenom}
            />)
        );
        const competencesChips = [];
        const input_competences_mobilisees = this.state.input_competences_mobilisees;
        for (let i = 0; i < input_competences_mobilisees.length; i++) {
            let p = input_competences_mobilisees[i];
            competencesChips.push(<Chip
                onRequestDelete={() =>
                    this.setState(
                        {
                            input_competences_mobilisees:
                                input_competences_mobilisees.filter(c => c !== p)

                        })
                }
                key={i}
                style={styles.chip}>{p}</Chip>);
        }
        return salariesCmpList.length > 0 && this.state.selectedSalarie ? (
                <CustomPaper title='Expériences professionelles'>
                    <div className={'row justify-content-center'}>
                        <SelectField
                            value={this.state.selectedSalarie.id}
                            floatingLabelText='Salarié à éditer'
                            onChange={(x, y, z) => this.props.history.push('/entreprise/experiences_pro_salarie/' + z)}
                            maxHeight={400}
                        >
                            {salariesCmpList}
                        </SelectField>
                    </div>
                    <div className="alert alert-primary" role="alert" style={{marginTop: 20}}>Veuillez renseigner
                        ci-dessous le(s) poste(s) occupé(s) dans
                        l'entreprise
                    </div>
                    <div style={{paddingBottom: 10}}>
                        <ValidatorForm
                            ref="form"
                            onSubmit={this.handleSubmit}
                        >
                            <TextValidator
                                value={this.state.input_poste_occupe}
                                onChange={this.handleChange}
                                fullWidth={true}
                                name='input_poste_occupe'
                                type="text"
                                validators={['required']}
                                errorMessages={['Ce champs est obligatoire']}
                                floatingLabelText="Poste"
                            /><br/>
                            {competencesChips.length > 0 &&
                            <div style={styles.wrapper}>{competencesChips}</div>}
                            <TextValidator
                                value={this.state.input_competence}
                                onChange={this.handleCompetenceChange}
                                fullWidth={true}
                                name='input_competence'
                                type="text"
                                validators={[]}
                                errorMessages={[]}
                                floatingLabelText="Comptéteces mobilisées dans ce poste : (appuyer sur ; pour ajouter une
                                    comptétence)"
                            /><br/>
                            <CustomDatePicker
                                floatingLabelText="Début"
                                stringValue={this.state.input_date_debut}
                                onChange={(x, y) => this.handleChange({target: {name: 'input_date_debut'}}, y)}
                            /><br/>
                            <Checkbox
                                labelPosition="right"
                                id="input_is_current_emploi"
                                checked={this.state.input_is_current_emploi}
                                onCheck={(x, y, z) => this.setState({input_is_current_emploi: y})}
                            />
                            <label htmlFor="input_is_current_emploi">Veuillez cocher cette case si le salarié occupe
                                actuellement ce
                                poste.</label><br/>
                            <CustomDatePicker
                                disabled={this.state.input_is_current_emploi}
                                floatingLabelText="Fin"
                                stringValue={this.state.input_date_fin}
                                onChange={(x, y) => this.handleChange({target: {name: 'input_date_fin'}}, y)}
                            /><br/>
                            <RaisedButton primary={true} label="Ajouter" type="submit"/><br/>
                        </ValidatorForm>
                        {
                            this.state.selectedSalarie && this.state.selectedSalarie.emplois && this.state.selectedSalarie.emplois.length > 0 &&
                            <table className="table" style={{marginTop: 10}}>
                                <thead>
                                <tr>
                                    <th>Poste</th>
                                    <th>Compétences mobilisées</th>
                                    <th>Date début</th>
                                    <th>Date Fin</th>
                                    <th>Poste Actuel</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.selectedSalarie.emplois.map((x, index) =>
                                        <tr key={index}>
                                            <td>{x.title}</td>
                                            <td>
                                                {x.competences.map(c => <div key={c}>{c}</div>)}
                                            </td>
                                            <td>{moment(x.date_debut).format('DD/MM/YYYY')}</td>
                                            <td>{x.is_current === '1' ? "-" : moment(x.date_fin).format('DD/MM/YYYY')}</td>
                                            <td>{x.is_current === '1' ? 'Oui' : 'Non'}</td>
                                            <td style={{cursor: 'pointer'}}
                                                onClick={() => this.handleEmploiDelete(x)}>X
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        }
                    </div>
                </CustomPaper>
            ) :
            <Alert text="Veuillez d'abord ajouter des salarié."/>
            ;
    }
}

function mapStateToProps(store) {
    return {salaries: store.entreprise.entreprise_infos.salaries}
}

export default connect(mapStateToProps)(ExperienceProSalarie);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/ExprerienceProSalarie.js